module.exports = __webpack_public_path__ + "static/media/fact-checker-banner.64d1b588.webp";